// import logo from './logo.svg';
import './App.css';
import LanguageChooser from './Components/LanguageChooser/LanguageChooser';
import AppProvider from './Context/appProvider';
import {
    Outlet
  } from "react-router-dom";
import SettingsProvider from './Context/settingsProvider';
import Notifications from './Components/Notifications/Notifications';
import SideBar from './Components/Sideabar';

function Root() {
  return (
    <AppProvider>
        <SettingsProvider>
           <div className='w-full h-screen flex'>
              <SideBar />
              <div className='h-screen flex-1 flex bg-[#f2f2f2] overflow-y-auto  max-md:ml-[0px] ml-[50px] w-full'>
                <Outlet />
              </div>
              </div>
            <LanguageChooser />
            <Notifications />
        </SettingsProvider>

    </AppProvider>
  );
}

export default Root;